/* JLD mobile menu (6.10.2026): drill-down views inside the header drawer. Markup: snippets/mnav-jld.liquid */
(function () {
  if (customElements.get('jld-mnav')) return;

  class JldMnav extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.stack = ['main'];
      this.triggers = [];
      this.details = this.closest('details');
      // Capture phase on purpose: the theme's drawer binds "close submenu" to every button inside it,
      // so clicks on our buttons are handled here and never reach that handler.
      this.addEventListener('click', this.onClick.bind(this), true);
      // Escape inside a submenu goes back one level; on the first view the theme closes the drawer as before.
      this.addEventListener(
        'keyup',
        (event) => {
          if (event.code !== 'Escape' || this.stack.length < 2) return;
          event.stopPropagation();
          this.back();
        },
        true
      );
      if (this.details) {
        new MutationObserver(() => {
          if (this.details.hasAttribute('open')) this.warm('main', true);
          else this.reset();
        }).observe(this.details, { attributes: true, attributeFilter: ['open'] });
      }
      this.watchCart();
      // Thumbnails are lazy; the first view's four pictures are fetched once the page is idle so the menu opens without blanks.
      const idle = () => (window.requestIdleCallback || window.setTimeout)(() => this.load(this.view('main')), { timeout: 4000 });
      if (document.readyState === 'complete') idle();
      else window.addEventListener('load', idle, { once: true });
    }

    load(view) {
      if (view) view.querySelectorAll('img[loading="lazy"]').forEach((img) => (img.loading = 'eager'));
    }

    // Fetch the pictures of the views that are one tap away from the given view.
    warm(id, self) {
      const view = this.view(id);
      if (!view) return;
      if (self) this.load(view);
      view.querySelectorAll('[data-jmn-open]').forEach((button) => this.load(this.view(button.dataset.jmnOpen)));
    }

    view(id) {
      return this.querySelector('[data-jmn-view="' + id + '"]');
    }

    onClick(event) {
      const target = event.target;
      const button = target.closest('button');
      if (button && this.contains(button)) {
        event.stopPropagation();
        if (button.hasAttribute('data-jmn-open')) this.open(button.dataset.jmnOpen, button);
        else if (button.hasAttribute('data-jmn-back')) this.back();
        else if (button.hasAttribute('data-jmn-close')) this.close();
        return;
      }
      if (target.closest('[data-jmn-search]')) {
        const toggle = this.searchToggle();
        if (toggle) {
          event.preventDefault();
          event.stopPropagation();
          this.close();
          toggle.click();
        }
        return;
      }
      if (target.closest('[data-jmn-cart]')) {
        const bubble = document.getElementById('cart-icon-bubble');
        if (bubble && document.querySelector('cart-drawer')) {
          event.preventDefault();
          event.stopPropagation();
          this.close();
          bubble.click();
        }
      }
    }

    // The theme's own search popup (with predictive search) is reused instead of a second search.
    searchToggle() {
      const toggles = document.querySelectorAll('details-modal.header__search > details > summary');
      for (const toggle of toggles) {
        if (toggle.getClientRects().length) return toggle;
      }
      return null;
    }

    open(id, trigger) {
      const next = this.view(id);
      const current = this.view(this.stack[this.stack.length - 1]);
      if (!next || !current || next === current || this.stack.indexOf(id) !== -1) return;
      current.classList.remove('is-active');
      current.classList.add('is-prev');
      next.classList.remove('is-prev');
      next.classList.add('is-active');
      next.scrollTop = 0;
      this.stack.push(id);
      this.triggers.push(trigger);
      trigger.setAttribute('aria-expanded', 'true');
      this.dataset.level = this.stack.length;
      this.warm(id);
      const back = this.querySelector('[data-jmn-back]');
      if (back) back.focus({ preventScroll: true });
    }

    back() {
      if (this.stack.length < 2) return;
      const current = this.view(this.stack.pop());
      const trigger = this.triggers.pop();
      const previous = this.view(this.stack[this.stack.length - 1]);
      current.classList.remove('is-active');
      previous.classList.remove('is-prev');
      previous.classList.add('is-active');
      this.dataset.level = this.stack.length;
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus({ preventScroll: true });
      }
    }

    close() {
      const summary = this.details && this.details.querySelector(':scope > summary');
      if (summary) summary.click();
    }

    reset() {
      this.classList.add('is-instant');
      this.querySelectorAll('[data-jmn-view]').forEach((view) => {
        view.classList.remove('is-prev');
        view.classList.toggle('is-active', view.dataset.jmnView === 'main');
      });
      this.querySelectorAll('[data-jmn-open][aria-expanded="true"]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
      this.stack = ['main'];
      this.triggers = [];
      this.dataset.level = 1;
      requestAnimationFrame(() => requestAnimationFrame(() => this.classList.remove('is-instant')));
    }

    watchCart() {
      const out = this.querySelector('[data-jmn-count]');
      const source = document.getElementById('cart-icon-bubble');
      if (!out || !source) return;
      const sync = () => {
        const bubble = source.querySelector('.cart-count-bubble');
        const number = bubble && bubble.querySelector('span[aria-hidden]');
        out.textContent = !bubble ? '0' : number ? number.textContent.trim() : '99+';
      };
      sync();
      new MutationObserver(sync).observe(source, { childList: true, subtree: true, characterData: true });
    }
  }

  customElements.define('jld-mnav', JldMnav);
})();
